import { PropsWithChildren } from "react";
import { TextLabel } from "./text";
import { Col } from "./col";

type Props = PropsWithChildren<{
  error?: string;
  label?: string;
}>;

export function Input({ error, label, children }: Props) {
  return (
    <Col mb="6">
      {!!label && (
        <TextLabel em ml="6" mb="2">
          {label.toUpperCase()}
        </TextLabel>
      )}
      {children}
      {!!error && (
        <TextLabel color="onError" m="2">
          {error}
        </TextLabel>
      )}
    </Col>
  );
}
